import Box from '@mui/material/Box'
import { avatarColors, AvatarColorKey, initialFor } from './avatarColor'

interface Props {
   name: string
   colorKey: AvatarColorKey
   size?: number
   deactivated?: boolean
}

export default function Avatar({ name, colorKey, size = 24, deactivated }: Props) {
   const { background, foreground } = avatarColors(colorKey, !!deactivated)

   return <Box
      component="span"
      aria-hidden="true"
      sx={{
         width: size,
         height: size,
         borderRadius: '9999px',
         background,
         color: foreground,
         display: 'inline-flex',
         alignItems: 'center',
         justifyContent: 'center',
         fontSize: Math.round(size * 0.46),
         fontWeight: 500,
         flexShrink: 0,
         letterSpacing: 0,
         opacity: deactivated ? 0.85 : 1,
      }}
   >
      {initialFor(name)}
   </Box>
}
